/* eslint-disable no-await-in-loop */
import React from 'react'
import flowRight from 'lodash/flowRight'
import { Route, Switch } from 'react-router-dom'

import Layout from './features/Layout'
import {
  AccountDetails,
  AccountSearch,
  AccountStatement,
  ApplicationDetails,
  ApplicationSearchGeneral,
  ClientDetails,
  ClientSearchGeneral,
  CollateralDetails,
  CollateralSearch,
  FileDetails,
  Home,
  LoanDetails,
  LoanSearch,
  LogSearch,
  OrderDetails,
  OrderSearch,
  UCCQueue,
  PlayGround,
  LoanCalculator,
  Turnover,
  About,
  Reporting,
  CCYRates,
  Templates,
  AMLClient,
} from './features'
import { withAuthGuard } from './common/authGuards'

// const wait = time => {
//   return new Promise(resolve => {
//     setTimeout(resolve, time)
//   })
// }

// const submit = (resolve, extra) => {
//   setTimeout(() => {
//     const submitButton = document.querySelector(`.search-form-container .lk-icon-button${extra || ''}`)
//     if (submitButton) {
//       submitButton.click()
//       resolve()
//     } else submit(resolve, extra)
//   }, 1000)
// }

// const submitForm = extra => {
//   return new Promise(resolve => {
//     submit(resolve, extra)
//   })
// }

// const closeModal = async () => {
//   return new Promise(resolve => {
//     setTimeout(() => {
//       const closeIcon = document.querySelector('.ui.modal .close.icon')
//       if (closeIcon) closeIcon.click()
//       resolve()
//     }, 6000)
//   })
// }

// const openModals = async () => {
//   document.querySelector('.client_add').click()
//   wait(1000)
//   document.querySelector('button.okay-button').click()
//   await closeModal()

//   document.querySelector('.application_add').click()
//   await closeModal()

//   document.querySelector('.collateral_add').click()
//   await closeModal()

//   document.querySelector('.abacus').click()
//   await closeModal()

//   document.querySelector('.entries_cashin').click()
//   await closeModal()

//   document.querySelector('.entries_convcash').click()
//   await closeModal()
// }

// const start = async history => {
//   while (true) {
//     history.push('/secure/client/searchGeneral')
//     await wait(2000)
//     await submitForm()
//     await wait(4000)

//     openModals()

//     history.push('/secure/application/search')
//     await wait(2000)
//     await submitForm()
//     await wait(4000)

//     history.push('/secure/client/risks')
//     await wait(2000)
//     await submitForm()
//     await wait(4000)

//     history.push('/secure/loan/search')
//     await wait(2000)
//     await submitForm()
//     await wait(4000)

//     history.push('/secure/reporting')
//     await wait(4000)
//     document.querySelector('.Reporting-searchBar button').click()
//     await wait(5000)

//     history.push('/secure/collateral/search')
//     await wait(2000)
//     await submitForm()
//     await wait(4000)

//     history.push('/secure/account/search')
//     await wait(2000)
//     await submitForm()
//     await wait(4000)

//     history.push('/secure/order/search')
//     await wait(2000)
//     await submitForm('.lk-button-container')
//     await wait(4000)

//     history.push('/secure/account/turnover')
//     await wait(3000)
//     document.querySelector('.ui.button.lk-button.lk-justify-center').click()
//   }
// }

const SecureRoutes = () => {
  // to start memory crasher uncomment this
  // React.useEffect(() => {
  //   start(history)
  // }, [])

  return (
    <Layout>
      <Switch>
        <Route path="/secure/client/searchGeneral" component={ClientSearchGeneral} />
        <Route path="/secure/client/risks" component={AMLClient} />
        <Route path="/secure/client/:ID/details/:hash/:type" component={ClientDetails} />
        <Route path="/secure/application/search" component={ApplicationSearchGeneral} />
        <Route path="/secure/application/:ID/details/:hash/:type?" component={ApplicationDetails} />
        <Route path="/secure/loan/search" component={LoanSearch} />
        <Route path="/secure/loan/calculator" component={LoanCalculator} />
        <Route path="/secure/loan/:ID/details/:hash" component={LoanDetails} />
        <Route path="/secure/collateral/search" component={CollateralSearch} />
        <Route path="/secure/collateral/:ID/details/:hash/:type" component={CollateralDetails} />
        <Route path="/secure/account/search" component={AccountSearch} />
        <Route path="/secure/account/turnover" component={Turnover} />
        <Route path="/secure/account/templates" component={Templates} />
        <Route path="/secure/account/:ID/details/:hash/:type?" component={AccountDetails} />
        <Route path="/secure/account/:ID/statement/:hash" component={AccountStatement} />
        <Route path="/secure/order/search" component={OrderSearch} />
        <Route path="/secure/order/:ID/details/:hash/:type/:OID?/:OHash?" component={OrderDetails} />
        <Route path="/secure/ucc/queue" component={UCCQueue} />
        <Route path="/secure/ucc/CCYRates" component={CCYRates} />
        <Route path="/secure/file/:ID/details/:hash/:type" component={FileDetails} />
        <Route path="/secure/reporting" component={Reporting} />
        <Route path="/secure/play-ground" component={PlayGround} />
        <Route path="/secure/about" component={About} />
        <Route path="/secure/log/search" component={LogSearch} />
        <Route exact path="" component={Home} />
      </Switch>
    </Layout>
  )
}

const enhance = flowRight(withAuthGuard, React.memo)

export default enhance(SecureRoutes)
